import bgCommon from './bg/common.json';
import bgMultiStyleText from './bg/multi-style-text.json';
import bgPages from './bg/pages.json';
import bgQuestions from './bg/questions.json';
import bgStepTitle from './bg/step-title.json';
import csCommon from './cs/common.json';
import csMultiStyleText from './cs/multi-style-text.json';
import csPages from './cs/pages.json';
import csQuestions from './cs/questions.json';
import csStepTitle from './cs/step-title.json';
import daCommon from './da/common.json';
import daMultiStyleText from './da/multi-style-text.json';
import daPages from './da/pages.json';
import daQuestions from './da/questions.json';
import daStepTitle from './da/step-title.json';
import deAtCommon from './de-AT/common.json';
import deAtMultiStyleText from './de-AT/multi-style-text.json';
import deAtPages from './de-AT/pages.json';
import deAtQuestions from './de-AT/questions.json';
import deAtStepTitle from './de-AT/step-title.json';
import deCommon from './de/common.json';
import deMultiStyleText from './de/multi-style-text.json';
import dePages from './de/pages.json';
import deQuestions from './de/questions.json';
import deStepTitle from './de/step-title.json';
import elCommon from './el/common.json';
import elMultiStyleText from './el/multi-style-text.json';
import elPages from './el/pages.json';
import elQuestions from './el/questions.json';
import elStepTitle from './el/step-title.json';
import enUsCommon from './en-US/common.json';
import enUsMultiStyleText from './en-US/multi-style-text.json';
import enUsPages from './en-US/pages.json';
import enUsQuestions from './en-US/questions.json';
import enUsStepTitle from './en-US/step-title.json';
import enCommon from './en/common.json';
import enMultiStyleText from './en/multi-style-text.json';
import enPages from './en/pages.json';
import enQuestions from './en/questions.json';
import enStepTitle from './en/step-title.json';
import esEsCommon from './es-ES/common.json';
import esEsMultiStyleText from './es-ES/multi-style-text.json';
import esEsPages from './es-ES/pages.json';
import esEsQuestions from './es-ES/questions.json';
import esEsStepTitle from './es-ES/step-title.json';
import etCommon from './et/common.json';
import etMultiStyleText from './et/multi-style-text.json';
import etPages from './et/pages.json';
import etQuestions from './et/questions.json';
import etStepTitle from './et/step-title.json';
import fiCommon from './fi/common.json';
import fiMultiStyleText from './fi/multi-style-text.json';
import fiPages from './fi/pages.json';
import fiQuestions from './fi/questions.json';
import fiStepTitle from './fi/step-title.json';
import frCommon from './fr/common.json';
import frMultiStyleText from './fr/multi-style-text.json';
import frPages from './fr/pages.json';
import frQuestions from './fr/questions.json';
import frStepTitle from './fr/step-title.json';
import gaCommon from './ga/common.json';
import gaMultiStyleText from './ga/multi-style-text.json';
import gaPages from './ga/pages.json';
import gaQuestions from './ga/questions.json';
import gaStepTitle from './ga/step-title.json';
import hrCommon from './hr/common.json';
import hrMultiStyleText from './hr/multi-style-text.json';
import hrPages from './hr/pages.json';
import hrQuestions from './hr/questions.json';
import hrStepTitle from './hr/step-title.json';
import huCommon from './hu/common.json';
import huMultiStyleText from './hu/multi-style-text.json';
import huPages from './hu/pages.json';
import huQuestions from './hu/questions.json';
import huStepTitle from './hu/step-title.json';
import itCommon from './it/common.json';
import itMultiStyleText from './it/multi-style-text.json';
import itPages from './it/pages.json';
import itQuestions from './it/questions.json';
import itStepTitle from './it/step-title.json';
import lbCommon from './lb/common.json';
import lbMultiStyleText from './lb/multi-style-text.json';
import lbPages from './lb/pages.json';
import lbQuestions from './lb/questions.json';
import lbStepTitle from './lb/step-title.json';
import ltCommon from './lt/common.json';
import ltMultiStyleText from './lt/multi-style-text.json';
import ltPages from './lt/pages.json';
import ltQuestions from './lt/questions.json';
import ltStepTitle from './lt/step-title.json';
import lvCommon from './lv/common.json';
import lvMultiStyleText from './lv/multi-style-text.json';
import lvPages from './lv/pages.json';
import lvQuestions from './lv/questions.json';
import lvStepTitle from './lv/step-title.json';
import mtCommon from './mt/common.json';
import mtMultiStyleText from './mt/multi-style-text.json';
import mtPages from './mt/pages.json';
import mtQuestions from './mt/questions.json';
import mtStepTitle from './mt/step-title.json';
import nlBeCommon from './nl-BE/common.json';
import nlBeMultiStyleText from './nl-BE/multi-style-text.json';
import nlBePages from './nl-BE/pages.json';
import nlBeQuestions from './nl-BE/questions.json';
import nlBeStepTitle from './nl-BE/step-title.json';
import nlNlCommon from './nl-NL/common.json';
import nlNlMultiStyleText from './nl-NL/multi-style-text.json';
import nlNlPages from './nl-NL/pages.json';
import nlNlQuestions from './nl-NL/questions.json';
import nlNlStepTitle from './nl-NL/step-title.json';
import noCommon from './no/common.json';
import noMultiStyleText from './no/multi-style-text.json';
import noPages from './no/pages.json';
import noQuestions from './no/questions.json';
import noStepTitle from './no/step-title.json';
import plCommon from './pl/common.json';
import plMultiStyleText from './pl/multi-style-text.json';
import plPages from './pl/pages.json';
import plQuestions from './pl/questions.json';
import plStepTitle from './pl/step-title.json';
import ptPtCommon from './pt-PT/common.json';
import ptPtMultiStyleText from './pt-PT/multi-style-text.json';
import ptPtPages from './pt-PT/pages.json';
import ptPtQuestions from './pt-PT/questions.json';
import ptPtStepTitle from './pt-PT/step-title.json';
import roRoCommon from './ro-RO/common.json';
import roRoMultiStyleText from './ro-RO/multi-style-text.json';
import roRoPages from './ro-RO/pages.json';
import roRoQuestions from './ro-RO/questions.json';
import roRoStepTitle from './ro-RO/step-title.json';
import skCommon from './sk/common.json';
import skMultiStyleText from './sk/multi-style-text.json';
import skPages from './sk/pages.json';
import skQuestions from './sk/questions.json';
import skStepTitle from './sk/step-title.json';
import slCommon from './sl/common.json';
import slMultiStyleText from './sl/multi-style-text.json';
import slPages from './sl/pages.json';
import slQuestions from './sl/questions.json';
import slStepTitle from './sl/step-title.json';
import svCommon from './sv/common.json';
import svMultiStyleText from './sv/multi-style-text.json';
import svPages from './sv/pages.json';
import svQuestions from './sv/questions.json';
import svStepTitle from './sv/step-title.json';
import zhHansCommon from './zh-Hans/common.json';
import zhHansMultiStyleText from './zh-Hans/multi-style-text.json';
import zhHansPages from './zh-Hans/pages.json';
import zhHansQuestions from './zh-Hans/questions.json';
import zhHansStepTitle from './zh-Hans/step-title.json';

export const resources = {
  bg: {
    common: bgCommon,
    multiStyleText: bgMultiStyleText,
    pages: bgPages,
    questions: bgQuestions,
    stepTitle: bgStepTitle,
  },
  cs: {
    common: csCommon,
    multiStyleText: csMultiStyleText,
    pages: csPages,
    questions: csQuestions,
    stepTitle: csStepTitle,
  },
  da: {
    common: daCommon,
    multiStyleText: daMultiStyleText,
    pages: daPages,
    questions: daQuestions,
    stepTitle: daStepTitle,
  },
  de: {
    common: deCommon,
    multiStyleText: deMultiStyleText,
    pages: dePages,
    questions: deQuestions,
    stepTitle: deStepTitle,
  },
  // 'de-AT': {
  //   common: deAtCommon,
  //   multiStyleText: deAtMultiStyleText,
  //   pages: deAtPages,
  //   questions: deAtQuestions,
  //   stepTitle: deAtStepTitle,
  // },
  'de-AT': {
    common: deCommon,
    multiStyleText: deMultiStyleText,
    pages: dePages,
    questions: deQuestions,
    stepTitle: deStepTitle,
  },
  el: {
    common: elCommon,
    multiStyleText: elMultiStyleText,
    pages: elPages,
    questions: elQuestions,
    stepTitle: elStepTitle,
  },
  en: {
    common: enCommon,
    multiStyleText: enMultiStyleText,
    pages: enPages,
    questions: enQuestions,
    stepTitle: enStepTitle,
  },
  'en-US': {
    common: enUsCommon,
    multiStyleText: enUsMultiStyleText,
    pages: enUsPages,
    questions: enUsQuestions,
    stepTitle: enUsStepTitle,
  },
  'es-ES': {
    common: esEsCommon,
    multiStyleText: esEsMultiStyleText,
    pages: esEsPages,
    questions: esEsQuestions,
    stepTitle: esEsStepTitle,
  },
  et: {
    common: etCommon,
    multiStyleText: etMultiStyleText,
    pages: etPages,
    questions: etQuestions,
    stepTitle: etStepTitle,
  },
  fi: {
    common: fiCommon,
    multiStyleText: fiMultiStyleText,
    pages: fiPages,
    questions: fiQuestions,
    stepTitle: fiStepTitle,
  },
  fr: {
    common: frCommon,
    multiStyleText: frMultiStyleText,
    pages: frPages,
    questions: frQuestions,
    stepTitle: frStepTitle,
  },
  // ga: {
  //   common: gaCommon,
  //   multiStyleText: gaMultiStyleText,
  //   pages: gaPages,
  //   questions: gaQuestions,
  //   stepTitle: gaStepTitle,
  // },
  ga: {
    common: enCommon,
    multiStyleText: enMultiStyleText,
    pages: enPages,
    questions: enQuestions,
    stepTitle: enStepTitle,
  },
  hr: {
    common: hrCommon,
    multiStyleText: hrMultiStyleText,
    pages: hrPages,
    questions: hrQuestions,
    stepTitle: hrStepTitle,
  },
  hu: {
    common: huCommon,
    multiStyleText: huMultiStyleText,
    pages: huPages,
    questions: huQuestions,
    stepTitle: huStepTitle,
  },
  it: {
    common: itCommon,
    multiStyleText: itMultiStyleText,
    pages: itPages,
    questions: itQuestions,
    stepTitle: itStepTitle,
  },
  lb: {
    common: lbCommon,
    multiStyleText: lbMultiStyleText,
    pages: lbPages,
    questions: lbQuestions,
    stepTitle: lbStepTitle,
  },
  lt: {
    common: ltCommon,
    multiStyleText: ltMultiStyleText,
    pages: ltPages,
    questions: ltQuestions,
    stepTitle: ltStepTitle,
  },
  lv: {
    common: lvCommon,
    multiStyleText: lvMultiStyleText,
    pages: lvPages,
    questions: lvQuestions,
    stepTitle: lvStepTitle,
  },
  mt: {
    common: mtCommon,
    multiStyleText: mtMultiStyleText,
    pages: mtPages,
    questions: mtQuestions,
    stepTitle: mtStepTitle,
  },
  'nl-BE': {
    common: nlBeCommon,
    multiStyleText: nlBeMultiStyleText,
    pages: nlBePages,
    questions: nlBeQuestions,
    stepTitle: nlBeStepTitle,
  },
  'nl-NL': {
    common: nlNlCommon,
    multiStyleText: nlNlMultiStyleText,
    pages: nlNlPages,
    questions: nlNlQuestions,
    stepTitle: nlNlStepTitle,
  },
  no: {
    common: noCommon,
    multiStyleText: noMultiStyleText,
    pages: noPages,
    questions: noQuestions,
    stepTitle: noStepTitle,
  },
  pl: {
    common: plCommon,
    multiStyleText: plMultiStyleText,
    pages: plPages,
    questions: plQuestions,
    stepTitle: plStepTitle,
  },
  'pt-PT': {
    common: ptPtCommon,
    multiStyleText: ptPtMultiStyleText,
    pages: ptPtPages,
    questions: ptPtQuestions,
    stepTitle: ptPtStepTitle,
  },
  'ro-RO': {
    common: roRoCommon,
    multiStyleText: roRoMultiStyleText,
    pages: roRoPages,
    questions: roRoQuestions,
    stepTitle: roRoStepTitle,
  },
  sk: {
    common: skCommon,
    multiStyleText: skMultiStyleText,
    pages: skPages,
    questions: skQuestions,
    stepTitle: skStepTitle,
  },
  sl: {
    common: slCommon,
    multiStyleText: slMultiStyleText,
    pages: slPages,
    questions: slQuestions,
    stepTitle: slStepTitle,
  },
  sv: {
    common: svCommon,
    multiStyleText: svMultiStyleText,
    pages: svPages,
    questions: svQuestions,
    stepTitle: svStepTitle,
  },
  'zh-Hans': {
    common: zhHansCommon,
    multiStyleText: zhHansMultiStyleText,
    pages: zhHansPages,
    questions: zhHansQuestions,
    stepTitle: zhHansStepTitle,
  },
};
